import { render, staticRenderFns } from "./collapseContent.vue?vue&type=template&id=3ee0cabc&scoped=true"
import script from "./collapseContent.vue?vue&type=script&lang=js"
export * from "./collapseContent.vue?vue&type=script&lang=js"
import style0 from "./collapseContent.vue?vue&type=style&index=0&id=3ee0cabc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ee0cabc",
  null
  
)

export default component.exports